export default __webpack_public_path__ + "static/136-min-min-212deba1d607144bee942c6d691d34b7.jpg";